import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=3490c866&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3490c866')) {
      api.createRecord('3490c866', component.options)
    } else {
      api.reload('3490c866', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=3490c866&", function () {
      api.rerender('3490c866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/ForgotPassword.vue"
export default component.exports